import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { http } from '@/apis/aipass'
import { SurveyRequest, SurveySubmitResponse } from './survey-types'
import { env } from '@/libs/env'

export const submitSurvey = createAsyncThunk<SurveySubmitResponse, SurveyRequest, { rejectValue }>(
  'survey/submitSurvey',
  async (params, { rejectWithValue }) => {
    try {
      const response = await http({
        method: 'post',
        url: `${env('BASE_API_V3')}/guest/surveys`,
        data: params,
      })
      return response.data
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

interface SurveySubmitState {
  submitResponse: SurveySubmitResponse | null
  loading: boolean
}

const initialState: SurveySubmitState = {
  submitResponse: null,
  loading: false,
}

const surveySubmitSlice = createSlice({
  name: 'surveySubmit',
  initialState,
  reducers: {
    resetSurveySubmit: state => {
      state.submitResponse = null
      state.loading = false
    },
  },
  extraReducers: builder => {
    builder.addCase(submitSurvey.fulfilled, (state, action) => {
      state.submitResponse = action.payload
      state.loading = false
    })
    builder.addCase(submitSurvey.rejected, (state, action) => {
      state.loading = false
    })
    builder.addCase(submitSurvey.pending, state => {
      state.loading = true
    })
  },
})

export const { resetSurveySubmit } = surveySubmitSlice.actions
export const surveySubmitReducer = surveySubmitSlice.reducer
